import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=ecdc901e&scoped=true&"
import script from "./PersonalCenter.vue?vue&type=script&lang=js&"
export * from "./PersonalCenter.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/bootstrap.min.css?vue&type=style&index=0&id=ecdc901e&scoped=true&lang=css&"
import style1 from "./PersonalCenter.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PersonalCenter.vue?vue&type=style&index=2&id=ecdc901e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc901e",
  null
  
)

export default component.exports